document.onkeydown = function(evt) {
  evt = evt || window.event
  var isEscape = false

  if ("key" in evt) {
      isEscape = (evt.key === "Escape" || evt.key === "Esc")
  } else {
      isEscape = (evt.keyCode === 27)
  }

  if (isEscape) {
   	document.body.classList.remove("megamenu-open")
  }
}
